import { useState } from 'react';

const amenitiesList = ['WiFi', 'TV', 'AC', 'Heater', 'Mini Bar'];
const roomServicesList = ['24/7 Room Service', 'Laundry', 'Breakfast', 'Airport Pickup'];

const AddRoomType = () => {
  const [roomName, setRoomName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [tax, setTax] = useState('');
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [images, setImages] = useState([]);

  // Handle Image Upload
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const imagePreviews = files.map((file) => URL.createObjectURL(file));
    setImages(imagePreviews);
  };

  // Handle Checkbox Selection
  const handleCheckboxChange = (list, setList, item) => {
    setList(list.includes(item) ? list.filter((i) => i !== item) : [...list, item]);
  };

  // Handle Form Submission (for now, just logs data)
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      roomName,
      description,
      price,
      tax,
      selectedAmenities,
      selectedServices,
      images,
    });
    alert('Room Type added successfully! (Data logged in console)');
  };

  return (
    <div className=" mx-auto bg-white p-6 rounded-lg shadow-lg mt-24">
      <h2 className="text-2xl font-semibold mb-4">Add New Room Type</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Room Name */}
        <div>
          <label className="block font-medium">Room Type Name:</label>
          <input
            type="text"
            className="w-full p-2 border rounded-md"
            value={roomName}
            onChange={(e) => setRoomName(e.target.value)}
            required
          />
        </div>

        {/* Description */}
        <div>
          <label className="block font-medium">Description:</label>
          <textarea
            className="w-full p-2 border rounded-md"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        {/* Price & Tax */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block font-medium">Price:</label>
            <input
              type="number"
              className="w-full p-2 border rounded-md"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block font-medium">Tax %:</label>
            <input
              type="number"
              className="w-full p-2 border rounded-md"
              value={tax}
              onChange={(e) => setTax(e.target.value)}
              required
            />
          </div>
        </div>

        {/* Image Upload */}
        <div>
          <label className="block font-medium">Upload Room Images:</label>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageUpload}
            className="w-full p-2 border rounded-md"
          />
          <div className="mt-2 flex gap-2 flex-wrap">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="Room Preview"
                className="w-24 h-24 object-cover rounded-md"
              />
            ))}
          </div>
        </div>

        {/* Amenities Selection */}
        <div>
          <label className="block font-medium">Select Amenities:</label>
          <div className="grid grid-cols-2 gap-2">
            {amenitiesList.map((amenity, index) => (
              <label key={index} className="flex items-center">
                <input
                  type="checkbox"
                  checked={selectedAmenities.includes(amenity)}
                  onChange={() =>
                    handleCheckboxChange(selectedAmenities, setSelectedAmenities, amenity)
                  }
                  className="mr-2"
                />
                {amenity}
              </label>
            ))}
          </div>
        </div>

        {/* Room Services Selection */}
        <div>
          <label className="block font-medium">Select Room Services:</label>
          <div className="grid grid-cols-2 gap-2">
            {roomServicesList.map((service, index) => (
              <label key={index} className="flex items-center">
                <input
                  type="checkbox"
                  checked={selectedServices.includes(service)}
                  onChange={() =>
                    handleCheckboxChange(selectedServices, setSelectedServices, service)
                  }
                  className="mr-2"
                />
                {service}
              </label>
            ))}
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
        >
          Add Room Type
        </button>
      </form>
    </div>
  );
};

export default AddRoomType;
